import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { IconButton } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

function Businesspagination() {
    return (<>
        <div className='row ps-4 pe-4 mt-4'>
            <div className='col-lg-4 col-md-4 col-sm-12'>
                <div className='pag_no'>
                    <p>1 of 10</p>
                </div>
            </div>
            <div className='col-lg-8 col-md-8 col-sm-12 paginantion_div'>
                <Stack spacing={2}>
                    <Pagination
                        nextIconButton={
                            <IconButton aria-label="Next page">
                              <ArrowForward />
                              Next
                            </IconButton>
                          }
                          prevIconButton={
                            <IconButton aria-label="Previous page">
                              <ArrowBack />
                              Previous
                            </IconButton>
                          } count={10} shape="rounded" />

                </Stack>
            </div>
  
        </div>








    </>

    )
}

export default Businesspagination